import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=b341ea00&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=b341ea00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b341ea00",
  null
  
)

export default component.exports